import {EditorNumericSliderShowOptions} from '../../modules/editor/NumericSlider';
import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Vector2Like} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref, ref} from 'vue';

export class EditorNumericSliderStoreControllerClass {
	private static _instance: EditorNumericSliderStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNumericSliderStoreControllerClass());
	}

	private constructor() {}

	private _param_id: Ref<CoreGraphNodeId | null> = ref(null);
	private _position: Ref<Vector2Like> = ref({x: 0, y: 0});

	// getters

	param_id(): CoreGraphNodeId | null {
		return this._param_id.value;
	}
	position(): Vector2Like {
		return this._position.value;
	}

	// mutations
	open(options: EditorNumericSliderShowOptions): void {
		this._param_id.value = options.param_id;
		this._position.value.x = options.position.x;
		this._position.value.y = options.position.y;
	}
	close() {
		this._param_id.value = null;
	}
}

export const EditorNumericSliderStoreController = EditorNumericSliderStoreControllerClass.instance();
